import { createIsbotFromList, list } from 'isbot'
import { isSSR } from 'lib/helpers/isSSR/isSSR'

// Datadog Synthetics browser tests identify as `DatadogSynthetics`. Their RUM sessions are not billed
// and on-call relies on the "view session" link from a failed run, so they are not treated as bots.
const isbot = createIsbotFromList(list.filter((pattern) => pattern !== 'synthetic'))

/**
 * Whether the current browser identifies itself as a crawler, headless browser or other automation.
 * Always `false` on the server, where there is no user agent to inspect.
 */
export const isBotUserAgent = (): boolean => !isSSR() && isbot(navigator.userAgent)
